import AssetField from '../../../contentful/AssetField';
import EntityCollectionField from '../../../contentful/EntityCollectionField';
import {NavLink as Link} from 'react-router-dom';
import PublishStatusDot from '../../../misc/PublishStatusDot.js';
import entity from '../../../../model/entity';
import update from 'immutability-helper';
import React from 'react';

const createSearcher = (
  contentType,
  modelId
) => {
  return ({
    query,
    offset,
    limit
  }) => {
    return entity.search({
      query: query,
      offset: offset,
      limit: limit,
      contentType: contentType,
      options: {
        'fields.model.sys.id': modelId
      }
    });
  };
};

class Color extends React.Component {
  constructor(props) {
    super(props);
    this.handleAssetChange = this.handleAssetChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handlePublish = this.handlePublish.bind(this);
    this.handleFieldChange = this.handleFieldChange.bind(this);
  }

  handleSubmit(e) {
    e.preventDefault();
    this.props.onSave();
  }

  handlePublish(e) {
    e.preventDefault();
    this.props.onPublish();
  }

  handleAssetChange(name, asset) {
    const event = {
      target: {
        name: name,
        value: asset
      }
    };

    this.handleFieldChange(event);
  }

  handleFieldChange(e) {
    const newData = {
      color: {}
    };

    if (e.target.type === 'checkbox') {
      newData.color[e.target.name] = {
        $set: e.target.checked
      };
    } else {
      newData.color[e.target.name] = {
        $set: e.target.value
      };
    }

    const props = update(this.props, newData);

    this.props.onChange(props);
  }

  render() {
    if (this.props.color) {
      const color = this.props.color;
      const model = this.props.model;

      const makeName = model.make.name;

      // console.log('Color', color);
      // console.log("Model", model);

      const predefinedTags = [makeName, model.name, 'Farge'];

      return (
        <section className="color mf-padding-top-20">
          <ol className="breadcrumb">
            <li><Link to="/">Forsiden</Link></li>
            <li><Link to="/nybilinformasjon/">Nybilinformasjon</Link></li>
            <li>
              <Link to={`/modeller/${model.make.id}`}>{makeName}</Link>
            </li>
            <li>
              <Link to={`/modeller/${model.make.id}/modell/${model.id}`}>{model.name}</Link>
            </li>
            <li className="active">{color.name}</li>
          </ol>

          <form onSubmit={this.handleSubmit}>
            <div className="page-header">
              <div className="pull-right">
                {this.props.working &&
                    <span>&nbsp;<i className="fa fa-spinner fa-pulse fa-fw"></i> Arbeider...</span>
                }
                {!color.archived &&
                  <button
                    type="submit"
                    className="btn btn-default"
                    disabled={!this.props.modified || this.props.working}
                  >
                    {Boolean(color.id) &&
                        <span>Lagre</span>
                    }
                    {!color.id &&
                        <span>Opprett farge</span>
                    }
                  </button>
                }
                &nbsp;
                {color.id && <React.Fragment>
                  <button
                    type="button"
                    className="btn btn-success"
                    disabled={(color.published && !color.updated) || color.archived || this.props.working || this.props.modified}
                    onClick={(e) => {
                      e.preventDefault();
                      this.props.onPublish();
                    }}
                  >
                    <span>Publiser</span>
                  </button>
                  &nbsp;
                  <button
                    type="button"
                    className="btn btn-warning"
                    disabled={color.draft || this.props.working || this.props.modified}
                    onClick={(e) => {
                      e.preventDefault();
                      if (color.archived) {
                        this.props.onUnarchive();
                      } else {
                        this.props.onUnpublish();
                      }
                    }}
                  >
                    <span>Kladd</span>
                  </button>
                  &nbsp;
                  {!color.archived &&
                    <button
                      type="button"
                      className="btn btn-danger"
                      disabled={this.props.working}
                      onClick={(e) => {
                        e.preventDefault();
                        this.props.onArchive();
                      }}
                    >
                      <span>Arkiver</span>
                    </button>
                  }
                  &nbsp;
                  {color.archived &&
                    <button
                      type="button"
                      className="btn btn-danger"
                      disabled={this.props.working}
                      onClick={(e) => {
                        e.preventDefault();
                        this.props.onUnarchive();
                      }}
                    >
                      <span>Gjenopprett</span>
                    </button>
                  }
                </React.Fragment>}
                <div className="text-right mf-padding-top-10">
                  <Link
                    className="btn btn-default"
                    to={`/modeller/${model.make.id}/modell/${model.id}`}
                  >
                    <i className="fa fa-arrow-left" aria-hidden="true"></i> Tilbake til {model.name}
                  </Link>
                </div>
              </div>

              <h1>
                {color.name} <PublishStatusDot entry={color} /><br />
                <small>{model.make.name} &ndash; <em>{model.name}</em></small>
              </h1>
            </div>

            {/* Display any error message: */}
            {this.props.error &&
                <div className="alert alert-danger">
                  {this.props.error}
                </div>
            }

            <div className="row">
              <div className="col-xs-12 col-md-6">
                <div className="form-group">
                  <label>Navn</label>
                  <input type="text" className="form-control" name="name" defaultValue={color.name} onChange={this.handleFieldChange} disabled={this.props.working || color.archived} />
                </div>

                <div className="form-group">
                  <label>Fargegruppe</label>
                  {color.allowedColorGroups &&
                    <select
                      type="text"
                      className="form-control"
                      name="colorGroup"
                      defaultValue={color.colorGroup}
                      disabled={this.props.working || color.archived}
                      onChange={this.handleFieldChange}
                    >
                      <option value="">-- Velg fargegruppe --</option>
                      {color.allowedColorGroups.map((group, key) => {
                        return <option key={key} value={group}>{group}</option>;
                      })}
                    </select>
                  }
                </div>

                <div className="form-group">
                  <label>Fargetype</label>
                  {/* <input type="text" className="form-control" name="type" defaultValue={color.name} onChange={this.handleFieldChange} disabled={this.props.working || color.archived} />*/}
                  <select
                    type="text"
                    className="form-control"
                    name="type"
                    defaultValue={color.type}
                    disabled={this.props.working || color.archived}
                    onChange={this.handleFieldChange}
                  >
                    <option value="">-- Velg fargetype --</option>
                    <option value="Metallic">Metallic</option>
                    <option value="Solid">Solid</option>
                    <option value="Mica">Mica</option>
                    <option value="Pearl">Pearl</option>
                  </select>
                </div>

                <div className="form-group">
                  <label>Ekstern ID</label>
                  <input type="text" className="form-control" name="externalId" defaultValue={color.externalId} onChange={this.handleFieldChange} disabled={this.props.working || color.archived} />
                </div>

                <div className="form-group">
                  <label>Fargereferanse</label>
                  <input type="text" className="form-control" name="reference" defaultValue={color.reference} onChange={this.handleFieldChange} disabled={this.props.working || color.archived} />
                </div>

                <div className="form-group">
                  <label>Pristillegg</label>
                  <div className="input-group">
                    <div className="input-group-addon">NOK</div>
                    <input type="text" className="form-control" name="priceAdjustment" defaultValue={color.priceAdjustment} disabled={this.props.working || color.archived} onChange={this.handleFieldChange} />
                    <div className="input-group-addon">,-</div>
                  </div>
                </div>

                <div className="form-group">
                  <label>Beskrivelse</label>
                  <textarea
                    className="form-control"
                    name="description"
                    rows="4"
                    value={color.description}
                    onChange={this.handleFieldChange}
                    disabled={this.props.working || color.archived}
                  ></textarea>
                </div>
              </div>

              <div className="col-xs-12 col-sm-6">
                <div className="form-group">
                  <h3>Fargen passer for følgende utstyrnivåer</h3>
                  <span className="help-block">
                      Dersom ingen er valgt, gjelder fargen for alle utstyrnivåer.
                  </span>
                  <EntityCollectionField
                    name="equipmentLevelWhitelist"
                    value={color.equipmentLevelWhitelist}
                    contentType="equipmentLevel"
                    onChange={this.handleAssetChange}
                    disabled={this.props.working || color.archived}
                    searcher={createSearcher('equipmentLevel', model.id)}
                    searchOnOpen={true}
                  />
                </div>

                {model.make.slug === 'hongqi' && <div className="form-group">
                  <label>Spesialbestilling</label>
                  <div className="checkbox">
                    <label>
                      <input type="checkbox" name="specialOrder" defaultChecked={color.specialOrder} onChange={this.handleFieldChange} disabled={this.props.working} />
                      Merk som spesialbestilling
                    </label>
                  </div>
                </div>}
              </div>
            </div>

            {/* IMAGES */}
            <div className="row">
              <div className="col-xs-12 col-md-6">
                <div className="form-group">
                  <label>Hovedbilde <em className="small text-muted">(Påkrevet)</em></label>
                  <AssetField
                    name="mainImage"
                    value={color.mainImage}
                    onChange={this.handleAssetChange}
                    disabled={this.props.working || color.archived}
                    predefinedTags={predefinedTags}
                  />
                </div>
              </div>

              <div className="col-xs-12 col-md-6">
                <div className="form-group">
                  <label>Silhuettbilde <em className="small text-muted">(Påkrevet)</em></label>
                  <AssetField
                    name="silhouetteImage"
                    value={color.silhouetteImage}
                    onChange={this.handleAssetChange}
                    disabled={this.props.working || color.archived}
                    predefinedTags={predefinedTags}
                  />
                </div>
              </div>
            </div>
          </form>
        </section>
      );
    }
  }
}

Color.defaultProps = {
  color: null,
  modified: null,
  working: null,
  onChange: () => {},
  onSave: () => {}
};

export default Color;
